import {VSWebClient} from './vsweb-client-impl'
module.exports = VSWebClient
export default VSWebClient


// WEBPACK FOOTER //
// ./base/vsweb-client.ts